export class CustomerSearchDto {
    CustomerDescription: string;
    InstanceId: number;
}
export class CustomerDto {
    ClientId: number;
    ClientNumber: string;
    ClientName: string;
}